import * as React from "react";
import { Divider, Flex, Text } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import NavigationSideItem from "./NavigationSideItem";
export default function NavigationSide({ onItemClick }) {
  const navigate = useNavigate();

  const handleItemClick = (sectionURL) => {
    navigate(sectionURL);
    if(onItemClick){
      onItemClick();
    }
  }

  return (
    <Flex direction="column">
      <Text children="Quick Actions"></Text>
      {/* <SwitchField label="Show tutorials"></SwitchField> */}
      <NavigationSideItem
        iconType="info"
        label="My Dashboard"
        onClick={() => handleItemClick("/user/quick-actions/insights")}
      />
      <NavigationSideItem
        iconType="favorite"
        label="Health Records"
        onClick={() => handleItemClick("/user/quick-actions/health-summary")}
      />
      <NavigationSideItem
        iconType="group"
        label="Care Groups"
        onClick={() => handleItemClick("/user/hr/care-groups")}
      />
      <NavigationSideItem
        iconType="chat"
        label="Care Notes"
        onClick={() => handleItemClick("/user/hr/care-notes")}
      />
      <NavigationSideItem
        iconType="storage"
        label="Personal Information"
        onClick={() => handleItemClick("/user/quick-actions/profile-summary")}
      />
      <Divider size="small" />
      <Text children="Fact Sheet Actions"></Text>
      <NavigationSideItem
        iconType="file"
        label="Download Fact Sheet"
        onClick={() => handleItemClick("/user/quick-actions/emergency-info")}
      />
      <NavigationSideItem
        iconType="file"
        label="Add a Customized Section"
        onClick={() => handleItemClick("/user/quick-actions/fact-sheets")}
      />
    </Flex>
  );
}
